export default "__VITE_ASSET__BYA00lcb__"